<template>
  <div class="bbp-index-cell"
       :class="{'bbp-index-cell_disabled': row.disabled}"
  >
    {{index + 1}}
  </div>
</template>

<script>
export default {
  name: 'BBPIndexCell',
  props: ['row', 'column', 'index']
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-index-cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    padding: 2px;
    background: rgba($color-accent, 0.15);
    border-radius: 50%;
    color: $color-accent;
    font-weight: bold;
    font-size: 11px;
    line-height: 1;
    cursor: default;

    &_disabled {
      background: $color-wild-sand;
      color: $color-silver;
    }

    &:after {
      content: "";
      padding-top: 100%;
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPIndexCell/BBPIndexCell.vue